import React from "react";
import { useTranslation } from "utilities/i18n";
import { Layout } from "views/Main/Layouts";
import { LicensingTable } from "../../Shared/LicenseKeys/List/LicensingTable";
import { GenerateMockLicenses } from "./GenerateMockLicenses";
import { DeleteMockLicenses } from "./DeleteMockLicenses";
import { LicenseTypeInput, useLicenseCountQuery } from "generated/graphql";

export const PolyPlusMockLicenses: React.FC<{
  tenantId: string;
}> = ({ tenantId }) => {
  const { t } = useTranslation();
  const { data } = useLicenseCountQuery({
    variables: { tenantId, type: LicenseTypeInput.MockOnly, canceled: false }
  });

  const { Content } = Layout;
  return (
    <Content
      className="poly-plus-mock-licenses"
      data-testid="poly-plus-mock-licenses"
    >
      <div className="table-heading">
        <span className="metric">{data?.licenseCount}</span>
        <span className="title ml-5">{t("MOCK_LICENSES")}</span>
      </div>
      <div className="grid">
        <div className="col-4">
          <GenerateMockLicenses tenantId={tenantId} />
        </div>
        <div className="col-4">
          <DeleteMockLicenses tenantId={tenantId} />
        </div>
      </div>
      <LicensingTable />
    </Content>
  );
};
